import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppMusicCopyrightOverviewVO } from '../Type/PackEntityAppMusicCopyrightOverviewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询音乐版权功能状态
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 */

export function appstatus(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityAppMusicCopyrightOverviewVO>
export function appstatus(
	data: DataModel,
	options?: IRequestOptions,
): Promise<
	PackEntityAppMusicCopyrightOverviewVO extends { msg: unknown }
		? PackEntityAppMusicCopyrightOverviewVO['msg']
		: undefined
>
export function appstatus(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/musicCopyright/app/status', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
